export default __webpack_public_path__ + "static/media/wireframes.e7d66294.svg";